import signedFetch from '../util/signedFetch.js';

export default ({ filters: { orgId } }) =>
  signedFetch('lmsConfig', `${__API_BASE__}/org/${encodeURIComponent(orgId)}/lms-config/tools`, 'GET');
